'use client'
import React, { useRef, useState } from 'react'
import { Popover } from 'antd'
import styles from './styled.module.scss'
import cls from 'classnames'
import { useLocale } from 'core/components/Locale'
import { useHCRouter } from '@/components/HCNextLink'
import AssetsOverview from './UserPanel/AssetsOverview'

const Wallet = () => {
  const [isOpen, setIsOpen] = useState(false)

  const t = useLocale()
  const router = useHCRouter()

  const handleNavigation = (item: any) => {
    if (item.meta?.auth) {
      router.push(`login`)
      return
    }
    router.push(item.link)
  }
  const accountList = [
    {
      key: 'home',
      title: '现货账户',
      link: '/assetManagement/home',
      locale: 'coinTrade_asset_012',
    },
    {
      key: 'margin',
      title: '杠杆账户',
      link: '/assetManagement/margin',
      locale: 'marginAccount_002',
    },
    {
      key: 'swaps',
      title: '合约账户',
      link: '/assetManagement/swaps',
      locale: 'header_040',
    },
    {
      key: 'account',
      title: 'C2C账户',
      link: '/c2c/account',
      locale: 'header_045',
    },
    {
      key: 'financialAccount',
      title: '理财账户',
      link: '/assetManagement/financialAccount',
      locale: 'financial_account_088',
    },
  ]

  const assetsOverviewRef = useRef(null)

  const handlePopoverChange = (visible: boolean) => {
    setIsOpen(visible)
    if (visible) {
      // Popover 打开时手动触发查询
      assetsOverviewRef.current?.refetch()
    }
  }

  const content = (
    <div>
      <AssetsOverview ref={assetsOverviewRef} visible={isOpen} />
      <div className={styles.walletFloor} style={{ marginTop: '26px' }}>
        <div className={styles.List}>
          <div className="font-bold f20" style={{ padding: '0 0 10px 0' }}>
            {t('header_042')}
          </div>
          {accountList.map((item, index) => (
            <div
              key={index}
              className={styles.listItem}
              style={{ width: '336px' }}
              onClick={() => handleNavigation(item)}
            >
              <div className={cls([styles.leftIcon, styles[item.key]])}></div>
              <div>{t(item.locale)}</div>
              <div></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
  return (
    <div className={styles.container}>
      <Popover
        trigger={'hover'}
        content={content}
        getPopupContainer={(node) => node.parentNode as HTMLElement}
        overlayInnerStyle={{ width: 380, height: 626, padding: '28px 24px' }}
        overlayClassName={cls(styles.popoverContent)}
        onOpenChange={handlePopoverChange}
        open={isOpen}
      >
        <div className={styles.searchIcon}>
          <i className="iconfont iconzhanghu-24 headers-iconfont f20"></i>
        </div>
        {/*<WalletMinimal size={20} />*/}
      </Popover>
    </div>
  )
}

export default Wallet
